// source: protocol_status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var header_entity_pb = require('./header_entity_pb.js');
goog.object.extend(proto, header_entity_pb);
var status_entity_pb = require('./status_entity_pb.js');
goog.object.extend(proto, status_entity_pb);
goog.exportSymbol('proto.himpb.SyncUserInfoBatchNty', null, global);
goog.exportSymbol('proto.himpb.UserLastStatusBatchNty', null, global);
goog.exportSymbol('proto.himpb.UserLastStatusNty', null, global);
goog.exportSymbol('proto.himpb.UserSessionCtrlNty', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.UserLastStatusNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.UserLastStatusNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.UserLastStatusNty.displayName = 'proto.himpb.UserLastStatusNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.UserSessionCtrlNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.UserSessionCtrlNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.UserSessionCtrlNty.displayName = 'proto.himpb.UserSessionCtrlNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.UserLastStatusBatchNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.UserLastStatusBatchNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.UserLastStatusBatchNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.UserLastStatusBatchNty.displayName = 'proto.himpb.UserLastStatusBatchNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SyncUserInfoBatchNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SyncUserInfoBatchNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.SyncUserInfoBatchNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SyncUserInfoBatchNty.displayName = 'proto.himpb.SyncUserInfoBatchNty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.UserLastStatusNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.UserLastStatusNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.UserLastStatusNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.UserLastStatusNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && status_entity_pb.TUserStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.UserLastStatusNty}
 */
proto.himpb.UserLastStatusNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.UserLastStatusNty;
  return proto.himpb.UserLastStatusNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.UserLastStatusNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.UserLastStatusNty}
 */
proto.himpb.UserLastStatusNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new status_entity_pb.TUserStatus;
      reader.readMessage(value,status_entity_pb.TUserStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.UserLastStatusNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.UserLastStatusNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.UserLastStatusNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.UserLastStatusNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      status_entity_pb.TUserStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.UserLastStatusNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.UserLastStatusNty} returns this
*/
proto.himpb.UserLastStatusNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.UserLastStatusNty} returns this
 */
proto.himpb.UserLastStatusNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.UserLastStatusNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TUserStatus status = 2;
 * @return {?proto.himpb.TUserStatus}
 */
proto.himpb.UserLastStatusNty.prototype.getStatus = function() {
  return /** @type{?proto.himpb.TUserStatus} */ (
    jspb.Message.getWrapperField(this, status_entity_pb.TUserStatus, 2));
};


/**
 * @param {?proto.himpb.TUserStatus|undefined} value
 * @return {!proto.himpb.UserLastStatusNty} returns this
*/
proto.himpb.UserLastStatusNty.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.UserLastStatusNty} returns this
 */
proto.himpb.UserLastStatusNty.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.UserLastStatusNty.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.UserSessionCtrlNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.UserSessionCtrlNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.UserSessionCtrlNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.UserSessionCtrlNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    devudid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    roomid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 5, 0),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.UserSessionCtrlNty}
 */
proto.himpb.UserSessionCtrlNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.UserSessionCtrlNty;
  return proto.himpb.UserSessionCtrlNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.UserSessionCtrlNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.UserSessionCtrlNty}
 */
proto.himpb.UserSessionCtrlNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDevudid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 6:
      var value = /** @type {!proto.himpb.ELineStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {!proto.himpb.ELineReason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.UserSessionCtrlNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.UserSessionCtrlNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.UserSessionCtrlNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.UserSessionCtrlNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDevudid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.UserSessionCtrlNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.UserSessionCtrlNty} returns this
*/
proto.himpb.UserSessionCtrlNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.UserSessionCtrlNty} returns this
 */
proto.himpb.UserSessionCtrlNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.UserSessionCtrlNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string userId = 2;
 * @return {string}
 */
proto.himpb.UserSessionCtrlNty.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.UserSessionCtrlNty} returns this
 */
proto.himpb.UserSessionCtrlNty.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string devUDID = 3;
 * @return {string}
 */
proto.himpb.UserSessionCtrlNty.prototype.getDevudid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.UserSessionCtrlNty} returns this
 */
proto.himpb.UserSessionCtrlNty.prototype.setDevudid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string roomId = 4;
 * @return {string}
 */
proto.himpb.UserSessionCtrlNty.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.UserSessionCtrlNty} returns this
 */
proto.himpb.UserSessionCtrlNty.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 timestamp = 5;
 * @return {number}
 */
proto.himpb.UserSessionCtrlNty.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.UserSessionCtrlNty} returns this
 */
proto.himpb.UserSessionCtrlNty.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional ELineStatus status = 6;
 * @return {!proto.himpb.ELineStatus}
 */
proto.himpb.UserSessionCtrlNty.prototype.getStatus = function() {
  return /** @type {!proto.himpb.ELineStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.himpb.ELineStatus} value
 * @return {!proto.himpb.UserSessionCtrlNty} returns this
 */
proto.himpb.UserSessionCtrlNty.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional ELineReason reason = 7;
 * @return {!proto.himpb.ELineReason}
 */
proto.himpb.UserSessionCtrlNty.prototype.getReason = function() {
  return /** @type {!proto.himpb.ELineReason} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.himpb.ELineReason} value
 * @return {!proto.himpb.UserSessionCtrlNty} returns this
 */
proto.himpb.UserSessionCtrlNty.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.UserLastStatusBatchNty.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.UserLastStatusBatchNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.UserLastStatusBatchNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.UserLastStatusBatchNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.UserLastStatusBatchNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    statusList: jspb.Message.toObjectList(msg.getStatusList(),
    status_entity_pb.TUserStatus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.UserLastStatusBatchNty}
 */
proto.himpb.UserLastStatusBatchNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.UserLastStatusBatchNty;
  return proto.himpb.UserLastStatusBatchNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.UserLastStatusBatchNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.UserLastStatusBatchNty}
 */
proto.himpb.UserLastStatusBatchNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new status_entity_pb.TUserStatus;
      reader.readMessage(value,status_entity_pb.TUserStatus.deserializeBinaryFromReader);
      msg.addStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.UserLastStatusBatchNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.UserLastStatusBatchNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.UserLastStatusBatchNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.UserLastStatusBatchNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getStatusList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      status_entity_pb.TUserStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.UserLastStatusBatchNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.UserLastStatusBatchNty} returns this
*/
proto.himpb.UserLastStatusBatchNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.UserLastStatusBatchNty} returns this
 */
proto.himpb.UserLastStatusBatchNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.UserLastStatusBatchNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TUserStatus status = 2;
 * @return {!Array<!proto.himpb.TUserStatus>}
 */
proto.himpb.UserLastStatusBatchNty.prototype.getStatusList = function() {
  return /** @type{!Array<!proto.himpb.TUserStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, status_entity_pb.TUserStatus, 2));
};


/**
 * @param {!Array<!proto.himpb.TUserStatus>} value
 * @return {!proto.himpb.UserLastStatusBatchNty} returns this
*/
proto.himpb.UserLastStatusBatchNty.prototype.setStatusList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.himpb.TUserStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TUserStatus}
 */
proto.himpb.UserLastStatusBatchNty.prototype.addStatus = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.himpb.TUserStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.UserLastStatusBatchNty} returns this
 */
proto.himpb.UserLastStatusBatchNty.prototype.clearStatusList = function() {
  return this.setStatusList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SyncUserInfoBatchNty.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SyncUserInfoBatchNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SyncUserInfoBatchNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SyncUserInfoBatchNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SyncUserInfoBatchNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    infosList: jspb.Message.toObjectList(msg.getInfosList(),
    status_entity_pb.TSyncUserInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SyncUserInfoBatchNty}
 */
proto.himpb.SyncUserInfoBatchNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SyncUserInfoBatchNty;
  return proto.himpb.SyncUserInfoBatchNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SyncUserInfoBatchNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SyncUserInfoBatchNty}
 */
proto.himpb.SyncUserInfoBatchNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new status_entity_pb.TSyncUserInfo;
      reader.readMessage(value,status_entity_pb.TSyncUserInfo.deserializeBinaryFromReader);
      msg.addInfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SyncUserInfoBatchNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SyncUserInfoBatchNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SyncUserInfoBatchNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SyncUserInfoBatchNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      status_entity_pb.TSyncUserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SyncUserInfoBatchNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SyncUserInfoBatchNty} returns this
*/
proto.himpb.SyncUserInfoBatchNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SyncUserInfoBatchNty} returns this
 */
proto.himpb.SyncUserInfoBatchNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SyncUserInfoBatchNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TSyncUserInfo infos = 2;
 * @return {!Array<!proto.himpb.TSyncUserInfo>}
 */
proto.himpb.SyncUserInfoBatchNty.prototype.getInfosList = function() {
  return /** @type{!Array<!proto.himpb.TSyncUserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, status_entity_pb.TSyncUserInfo, 2));
};


/**
 * @param {!Array<!proto.himpb.TSyncUserInfo>} value
 * @return {!proto.himpb.SyncUserInfoBatchNty} returns this
*/
proto.himpb.SyncUserInfoBatchNty.prototype.setInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.himpb.TSyncUserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSyncUserInfo}
 */
proto.himpb.SyncUserInfoBatchNty.prototype.addInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.himpb.TSyncUserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SyncUserInfoBatchNty} returns this
 */
proto.himpb.SyncUserInfoBatchNty.prototype.clearInfosList = function() {
  return this.setInfosList([]);
};


goog.object.extend(exports, proto.himpb);
